import * as React from 'react'
import { IWPGBlock } from 'react-gutenberg'

import SignupBanner from 'app/components/SignupCampaign/SignupBanner'

interface IAttributes {
  url: string
}

const SignupCampaignBlock: React.FC<IWPGBlock> = (props) => {
  const attributes = props.attrs as IAttributes

  return <SignupBanner url={attributes.url} />
}

export default SignupCampaignBlock
